import React, { useState, useContext, useEffect } from 'react';
import useForm from 'components/FormUse';
import Loading from 'components/Loading';
import LoginService from 'services/Login/service';
import SessionFactory from 'factories/Session';
import { AuthContext } from '../../auth/AuthContext';
import { types } from '../../types/types';
import PropTypes from 'prop-types';
import './style.scss';


//import { constants } from 'config';
const FormLogin = ({handleLoginValidation,handleLoginData}) => {

    
   
    const { sessionDispatch } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [processErrorMsg, setProcessErrorMsg] = useState('');
    const [ipPublic, setIpPublic] = useState('');
    const [loginValidation, setLoginValidation] = useState(false);

    useEffect(() => {
        // Use the incoming 'validate' prop here if you need it
        setLoginValidation(loginValidation);
        handleLoginValidation(loginValidation);  // Llama a la función de devolución de llamada
    }, [handleLoginValidation, loginValidation]);

    useEffect(() => {
        const getIpPublic = async () => {
          try {
            const timeoutPromise = new Promise((resolve) => {
              setTimeout(() => resolve(''), 6000);
            });
    
            const ipifyIpPublicPromise = Promise.race([
              LoginService.ipifyIpPublic(),
              timeoutPromise,
            ]);
    
            const ip_public = await ipifyIpPublicPromise.catch(() => '');
            setIpPublic(ip_public);
          } catch (error) {
            console.error(error);
          }
        };
    
        getIpPublic();
      }, []);


    const {
        handleSubmit,
        handleChange,
        data,
        errors,
    } = useForm({
        validations: {
            email: {
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Ingrese un email válido"
                }
            }, 
            password: {
                required: {
                    value: true, 
                    message: "Ingrese una contraseña"
                }
            }
        },
        onSubmit: async (data) => {
            setIsLoading(true);
            setProcessErrorMsg('');
            try{
                 
                const encrypter_pass = await LoginService.authEncrypter({ 'password': data.password });
                //login vtex
                const login_app = await LoginService.authLogin({
                    'userName': data.email,
                    'password': encrypter_pass.payload
                });
               
                if(!login_app || (login_app && !login_app.payload) || (login_app && login_app.internalCode!=='200')){
                    setIsLoading(false);
                    setProcessErrorMsg('Usuario y/o contraseña incorrecta');
                if(ipPublic){                  
                    // service usuariolog
                    await LoginService.crearUsuarioLog({ 
                    'internalCode':login_app.internalCode,
                    'jwt' :"",
                    'correo':data.email,
                    'ipPublica' :ipPublic ,
                    'ipPrivada' :"" ,
                    'tipoEvento':"Sign in (username)",
                    'timeSessionSeconds':0,
                    'descripcion' : '{encrypter  internalCode:'+encrypter_pass.internalCode+',message:'+encrypter_pass.message+'}'+
                    '{login internalCode:'+login_app.internalCode+',message:'+login_app.message+',payload:'+login_app.payload+'}' ,
                    'socialScope':"username"

                    });
                    //
                }
                   
                    return;
                }
                //login application
                Promise.all(  [  LoginService.authTokenCoupons({
                    'jwt': login_app.payload.tokenJwt,
                    'sessionType':"login"
                })]).then(([auth] )=> {
                    
                    SessionFactory.saveUpdateTries(auth.payload,'login');
                      
                    //date session
                      const iniciotimeSession=new Date();
                    if(ipPublic){
                       // service usuariolog
                        LoginService.crearUsuarioLog({
                        'internalCode': auth.internalCode,
                        'jwt':login_app.payload.tokenJwt,
                        'correo':data.userName,
                        'ipPublica':ipPublic,
                        'ipPrivada' :"" ,
                        'tipoEvento':"Sign in (username)",
                        'timeSessionSeconds':0,
                        'descripcion':"{loginApp internalCode:"+ auth.internalCode +",message:"+auth.message+"}",
                        'socialScope':"username"
                        
                        });
                        //
                    }
                        

                    if(!auth || !['200','201'].includes(auth.internalCode)){
                        console.log(auth);
                        setIsLoading(false);
                        setProcessErrorMsg('web coupones login failed');
                        return ;
                    }
                    if(['200','201'].includes(auth.internalCode) && (!auth.payload.validateUserByDni)){
                        setIsLoading(false);
                        setProcessErrorMsg('Actualizar datos');
                        setLoginValidation(true);
                        const loginData = {
                            loginApp: auth.payload,
                            login: login_app.payload.tokenJwt
                          };
              
                        handleLoginData(loginData);
                      
                        return;
                    }
                                        
                    sessionDispatch({
                        type: types.login,
                        payload: SessionFactory.initialize(auth.payload.additionalFields.jwt,login_app.payload.tokenJwt,iniciotimeSession,"username")
                        

                    
                    });
                    
                   
                });
                
               
                

            }catch(error){
                console.error(error);
            }
        },
        initialValues: {
            email: '', 
            password: ''
        }
    });

    return (
        <>
        <form onSubmit={handleSubmit}>
            <div className="form-group">
                <input value={data.email || ''} onChange={handleChange('email')} required maxLength="150" type="email" className="form-control" name="textBoxEmail" id="textBoxEmail" placeholder="Correo electrónico" />
                {errors.email && <p className="error-form">{errors.email}</p>}
            </div>
            <div className="form-group">
                <input value={data.password || ''} onChange={handleChange('password')} required maxLength="50" type="password" className="form-control" name="textBoxPassword" id="textBoxPassword" placeholder="Contraseña" />
                {errors.password && <p className="error-form">{errors.password}</p>}
            </div>
            <p className="text-right">
                <a href="/lost-password">¿Olvidaste tu contraseña?</a>
            </p>
            {processErrorMsg!=='' && <p className="text-center red-dark">{processErrorMsg}</p>}
            <p className="buttons text-center">
                <button type="submit" className="btn btn-main">
                    {isLoading ? <Loading type="metro--hover" /> : 'Ingresar'}
                </button>
            </p>
        </form>
       
        </>
    );
}
FormLogin.propTypes = {
    handleLoginValidation: PropTypes.func,
    handleLoginData:PropTypes.func
    
    
};

export default FormLogin;